import React from "react";
import PAYENumberValidation from "./PAYENumberValidation";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const PAYENumberComponent = (props) => {
  let { required, ...rest } = props;
  if (required === undefined) {
    required = true;
  }

  const isValid = (value) =>
    (!required && (!value || value.length === 0)) ||
    (value && PAYENumberValidation(value))
      ? undefined
      : "Please enter a valid PAYE Number";

  let { name } = props;
  if (name === undefined) {
    name = "taxnumber";
  }

  return (
    <Field
      name={name}
      validate={isValid}
      label="PAYE Number"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      inputProps={{ maxLength: 10 }}
      fullWidth
      {...rest}
    />
  );
};

export default PAYENumberComponent;
